<template>
  <div class="pt-3 px-3">
    <form-modal
      id="cronograma_financeiro"
      placeholder-button="Inserir parcelas"
      :fields="colunas"
      :values="dadosCalculados"
      @ok="salvar"
      @cancel="inicializarForm"
      @edit="editar"
      @remove="remover"
      ref="modal"
      title-modal="PARCELAS"
      :create="permissao.c && btnSalvar"
      :read="permissao.r"
      :update="permissao.u"
      :remove="permissao.d"
      :controles="!aprovada && !TelaProponente && !TelaProponenteCooperada"
    >
      <template #title>
        <span class="mr-4">PARCELAS</span>
        <b-badge> Total rubricas: </b-badge>
        <b-badge class="ml-2" variant="light">
          {{ formatarValor(totalDespesas.totalDespesas) }}
        </b-badge>

        <b-badge variant="warning" class="ml-4"> Total notas: </b-badge>
        <b-badge class="ml-2" variant="light">
          {{ formatarValor(totalDespesas.totalNotas) }}
        </b-badge>

        <b-badge variant="success" class="ml-4"> Total restante: </b-badge>
        <b-badge class="ml-2" variant="light">
          {{ formatarValor(totalDespesas.totalRestante) }}
        </b-badge>
      </template>
      <template #modal>
        <modal
          :editando="editando"
          @notas="atualizarTotalNotas"
          :total-despesas="totalDespesas"
          :proposta-id="propostaId"
          :duracao="duracao"
          :form="form"
          ref="form"
          :entregaveis="entregaveis"
        />
      </template>

      <template #beforeTable>
        <div>
          <div style="" class="pb-3">
            <div class="m-0 mt-3 mb-3">
              <vue-perfect-scrollbar class="col-12">
                <div class="d-flex">
                  <b-card
                    no-body
                    class="mr-2 card__no_shadow accord"
                    style="min-width: 200px"
                  >
                    <div class="card__title">
                      <span> Tipo </span>
                    </div>
                    <div class="card__row">
                      <span>
                        {{ nomeDashboard.rubricas }}
                      </span>
                    </div>
                    <div class="card__row">
                      <span>
                        {{ nomeDashboard.notas }}
                      </span>
                    </div>
                    <div class="card__row bg-yellow-200" v-if="temTotalizador">
                      <span> Total </span>
                    </div>
                  </b-card>

                  <b-card
                    no-body
                    class="mr-2 card__no_shadow accord"
                    style="min-width: 140px"
                  >
                    <div class="card__title bg-gradient-warning">
                      <span> Total </span>
                    </div>
                    <div class="card__row bg-yellow-100">
                      <span>
                        {{ formatarValor(totalDespesas.totalDespesas) }}
                      </span>
                    </div>
                    <div class="card__row bg-yellow-100">
                      <span> {{ formatarValor(totalDespesas.totalNotas) }} </span>
                    </div>

                    <div class="card__row bg-yellow-200" v-if="temTotalizador">
                      <span>
                        {{ formatarValor(totalDespesas.totalSoma) }}
                      </span>
                    </div>
                  </b-card>

                  <template v-for="(hora, i) in mesesDepesas">
                    <b-card
                      :key="i"
                      no-body
                      class="mr-2 card__no_shadow accord"
                      style="min-width: 140px"
                    >
                      <div class="card__title">
                        <span>
                          {{ hora.text }}
                        </span>
                      </div>

                      <b-tooltip :target="`valor-${i}`">
                        <div><b>RH: </b>{{ hora.rubricas.recursoHumano }}</div>
                        <div><b>ST: </b>{{ hora.rubricas.servicoTerceiro }}</div>
                        <div><b>MC: </b>{{ hora.rubricas.materialConsumo }}</div>
                        <div><b>MPE: </b>{{ hora.rubricas.materialPermanente }}</div>
                        <div><b>VD: </b>{{ hora.rubricas.viagemDiarias }}</div>
                        <div><b>OU: </b>{{ hora.rubricas.outrosRecursos }}</div>
                      </b-tooltip>
                      <div :id="`valor-${i}`" class="card__row">
                        <span>
                          {{ hora.valor }}
                        </span>
                      </div>
                      <div :id="`notas-${i}`" class="card__row">
                        <span>
                          {{ hora.notas }}
                        </span>
                      </div>
                      <div
                        :id="`notas-${i}`"
                        v-if="temTotalizador"
                        class="card__row bg-yellow-200"
                      >
                        <span>
                          {{ hora.total }}
                        </span>
                      </div>
                      <b-tooltip :target="`notas-${i}`" placement="bottom">
                        <div v-for="nota in hora.listaNotas" :key="nota.id">
                          <b>{{ nota.tipo }}:</b>
                          {{ nota.valor }}
                        </div>
                      </b-tooltip>
                    </b-card>
                  </template>
                </div>
              </vue-perfect-scrollbar>
            </div>
          </div>
        </div>
      </template>
    </form-modal>
  </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import Modal from "./modal";

import PropostaService from "@/common/services/proposta/proposta.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import helpers from "@/common/utils/helpers";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import cloneDeep from "lodash/cloneDeep";

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "PropostaCronogramaFinanceiro",
  mixins: [AlertasMixin],
  props: {
    propostaId: {
      required: true,
    },
    propostaOriginalId: {
      required: true,
    },
    duracao: {
      required: true,
    },
    value: {
      type: Object,
    },
    endpoint: {
      type: String,
      default: "Proposta",
    },
    aprovada: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormModal,
    Modal,
    VuePerfectScrollbar,
  },
  data: () => ({
    btnSalvar: false,
    colunas: [
      { key: "empresa", label: "Empresa recebedora" },
      { key: "tipo", label: "Tipo" },
      { key: "parcela", label: "Parcela" },
      { key: "empresaInvestidora", label: "Empresa investidora" },
      { key: "subtipo", label: "Produto vinculado",
        formatter: (a, b, c) => {
          if (!a) return "";
          if(a == 'AssinaturaDoContrato') {
            return `Assinatura do Contrato`;
          }
          if (!c.entregavel) return "";
          if (c.entregavel.tipo == "RelatorioAtividades" && c.entregavel.vinculadoARelatorioEtapa)
            return c.entregavel.relatorioEtapa.titulo;     

          let tipoEntregavel = helpers.getTipoEntregavel(c.entregavel.tipo.trim());
          let texto = tipoEntregavel.text;
          if (tipoEntregavel.value != tipoEntregavel.subtipo)
            texto = `${tipoEntregavel.text} - ${
              helpers.getEnum(tipoEntregavel.subtipo).text
            }`;
          return `${texto} ${c.entregavel.sequencial}`;
        },
      },
      {
        key: "prazo",
        label: "Previsão de desembolso",
        formatter: (value) => {
          if (value) return "Mês " + value;
        },
      },
      {
        key: "valor",
        label: "Valor",
        formatter: (value) => {
          if (value) return helpers.formatarValor(value);
        },
      },

      { key: "actions", label: "Ações" },
    ],

    form: [
      {
        propostaId: null,
        tipo: null,
        subtipo: null,
        valor: 0,
        prazo: 0,
        parcela: 0,
        propostaEmpresaInvestidoraId: null,
      },
    ],
    dados: [],
    accordions: {
      recursoHumano: null,
      servicoTerceiro: [],
      materialConsumo: [],
      materialPermanente: [],
      viagemDiarias: [],
      outrosRecursos: [],
    },
    entregaveis: [],
    totalNotas: 0,
    editando: false,
    valorAntigo: 0,
  }),
  methods: {
    atualizarTotalNotas(totalNotas) {
      this.totalNotas = totalNotas;
    },
    formatarValor(valor) {
      return helpers.formatarValor(valor);
    },
    buscarEntregavel: function () {
      PropostaService.buscarEntregavel(this.propostaOriginalId).then((response) => {
        this.entregaveis = response.data.data.sort((a, b) => {
          return (
            (a.vinculadoARelatorioEtapa ? a.relatorioEtapa.mesFinal : a.prazo) -
            (b.vinculadoARelatorioEtapa ? b.relatorioEtapa.mesFinal : b.prazo)
          );
        });
      });
    },
    salvar: function () {
      if (this.$refs.form.validateState() == false) return;

      this.confirmar("Deseja salvar a parcela?").then((confirmado) => {
        if (!confirmado) return;

        // if (this.totalDespesas.totalRestante < 0) {
        //   this.alertaErro(
        //     "O valor total das notas ficais não pode ser maior que o valor total das rubricas."
        //   );
        //   return;
        // }

        this.$store.dispatch(START_LOADING);

        let form = cloneDeep(this.form);

        form.forEach((item) => {
          item.propostaId = this.propostaId;
          item.propostaEmpresaProponenteId = this.propostaId;
          item.propostaEmpresaExecutoraId = this.propostaId;
          item.propostaEmpresaCooperadaId = this.propostaId;

          item.valor = helpers.removerValor(item.valor);

          PropostaService.salvarDesembolso(item)
            .then(() => {
              this.toastSucesso(`${item.tipo} salvo com sucesso!`);

              this.form.splice(
                this.form.indexOf(this.form.find((el) => el.tipo == item.tipo)),
                1
              );
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.toastErro(`Erro ao salvar ${item.tipo}: ${err.data.errors}`);
              } else {
                this.toastErro(`Erro ao salvar ${item.tipo}`);
              }
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        });
      });
    },

    editar: function (value) {
      this.editando = true;
      let form = cloneDeep(value);
      this.form = [];
      this.form.push(form);
      this.form[0].valor = helpers.formatarValor(form.valor);
      this.form[0].cronogramaFinanceiroId = this.form[0].id;
      this.$refs.modal.openModal();

      this.valorAntigo = cloneDeep(helpers.removerValor(form.valor));
    },

    remover: function (desembolso) {
      this.confirmar("Deseja excluir a parcela?").then((confirmado) => {
        if (!confirmado) return;

        let form = {
          cronogramaFinanceiroId: desembolso.id,
          propostaId: this.propostaId,
          propostaEmpresaProponenteId: this.propostaId,
          propostaEmpresaCooperadaId: this.propostaId,
        };

        this.$store.dispatch(START_LOADING);

        PropostaService.removerDesembolso(form)
          .then(() => {
            this.alertaSucesso(`${desembolso.tipo} excluído com sucesso!`).then(() => {
              this.montar();
              this.$nextTick(() => {
                this.$refs.modal.closeModal();
              });
            });
          })
          .catch(() => {
            this.alertaErro("Ocorreu um erro ao excluir a parcela!");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    inicializarForm: function () {
      this.totalNotas = 0;
      this.editando = false;
      this.valorAntigo = 0;
      this.form = [
        {
          propostaId: null,
          tipo: `Nota fiscal ${
            this.dados.length == 0
              ? 1
              : parseInt(
                  this.dados[this.dados.length - 1].tipo.replace("Nota fiscal ", "")
                ) + 1
          }`,
          subtipo: null,
          prazo: null,
          valor: 0,
          parcela:
            this.dados.length == 0 ? 1 : this.dados[this.dados.length - 1].parcela + 1,
          propostaEmpresaInvestidoraId: null,
        },
      ];
    },

    buscar: function () {
      this.btnSalvar = false;
      this.$store.dispatch(START_LOADING);
      /*if(this.TelaProponente || this.TelaProponenteCooperada)
                PropostaService.setEndpoint('Proposta');*/

      PropostaService.buscarDesembolsos(this.propostaId)
        .then((response) => {
          this.dados = response.data.data.sort((a, b) => {
            return a.parcela - b.parcela;
          });
        })
        .finally(() => {
          this.btnSalvar = true;
          this.inicializarForm();
          this.$store.dispatch(STOP_LOADING);
        });
      PropostaService.setEndpoint(this.endpoint);
    },

    buscarRubricas: function () {
      [
        { nomeVariavel: "recursoHumano", endpoint: "recurso-humano" },
        { nomeVariavel: "servicoTerceiro", endpoint: "servico-terceiro" },
        { nomeVariavel: "materialConsumo", endpoint: "material-consumo" },
        { nomeVariavel: "materialPermanente", endpoint: "material-permanente" },
        { nomeVariavel: "viagemDiarias", endpoint: "viagem-diaria" },
        { nomeVariavel: "outrosRecursos", endpoint: "outro-recurso" },
      ].forEach((element) => {
        PropostaService.buscarDespesa(this.propostaId, element.endpoint).then(
          (response) => {
            this.accordions[element.nomeVariavel] = response.data.data;
          }
        );
      });
    },

    montar() {
      this.buscar();
      this.inicializarForm();
      this.buscarRubricas();
      this.buscarEntregavel();
    },
  },
  watch: {
    form: {
      handler() {
        if (this.form.length == 0) {
          this.$refs.modal.closeModal();
          this.montar();
        }
      },
      deep: true,
    },
  },
  mounted: function () {
    if (!this.TelaProponente && !this.TelaProponenteCooperada)
      this.colunas.splice(
        this.colunas.indexOf(this.colunas.find((el) => el.key == "empresa")),
        1
      );
  },
  computed: {
    nomeDashboard() {
      if (
        this.$route.name == "proposta-executora-detalhamento" ||
        this.$route.name == "proposta-executora-associada-detalhamento"
      )
        return {
          rubricas: "Rubricas",
          notas: "nota fiscal",
          letra: "a",
        };
      else
        return {
          rubricas: "Custos próprios",
          notas: "Investimentos",
          letra: "o",
        };
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("PropostaCronogramaFinanceiro");
    },
    TelaProponente() {
      return this.endpoint == "PropostaEmpresaProponente";
    },
    TelaExecAssociada() {
      return this.endpoint == "PropostaEmpresaExecutora";
    },
    TelaProponenteCooperada() {
      return this.endpoint == "PropostaEmpresaCooperada";
    },

    temTotalizador: function () {
      return this.TelaProponente || this.TelaProponenteCooperada;
    },

    dadosCalculados: function () {
      let c = cloneDeep(this.dados);
      c.push({
        id: -1,
        tipo: "Total",
        valor: this.dados.reduce((total, el) => total + el.valor, 0),
        _rowVariant: "warning",
      });

      return c;
    },
    totalDespesas: function () {
      let totalDespesas = this.mesesDepesas
        .reduce((total, el) => total + el.valorSoma, 0)
        .toFixed(2);
      let totalNotas = (
        this.mesesDepesas.reduce((total, el) => total + el.valorNota, 0) +
        this.totalNotas -
        this.valorAntigo
      ).toFixed(2);
      return {
        totalDespesas: totalDespesas,
        totalNotas: totalNotas,
        totalSoma: parseFloat(totalDespesas) + parseFloat(totalNotas),
        totalRestante: (totalDespesas - totalNotas).toFixed(2),
      };
    },
    mesesDepesas: function () {
      let meses = [];
      for (let index = 1; index <= this.duracao; index++) {
        let recursoHumano = 0;

        if (this.accordions.recursoHumano) {
          this.accordions.recursoHumano.equipe.alocacaoHorasIndividuais.forEach(
            (element) => {
              if (element.horasSazonais.find((el) => el.mes == index - 1))
                recursoHumano +=
                  element.horasSazonais.find((el) => el.mes == index - 1).horas *
                  element.valorHora;
            }
          );
        }

        let servicoTerceiro = this.accordions.servicoTerceiro
          .filter((el) => el.mesDespesa == index)
          .reduce((total, el) => total + el.valor, 0);
        let materialConsumo = this.accordions.materialConsumo
          .filter((el) => el.mesDespesa == index)
          .reduce((total, el) => total + el.valor, 0);
        let materialPermanente = this.accordions.materialPermanente
          .filter((el) => el.mesDespesa == index)
          .reduce((total, el) => total + el.valor, 0);
        let viagemDiarias = this.accordions.viagemDiarias
          .filter((el) => el.mesDespesa == index)
          .reduce((total, el) => total + el.valor, 0);
        let outrosRecursos = this.accordions.outrosRecursos
          .filter((el) => el.mesDespesa == index)
          .reduce((total, el) => total + el.valor, 0);

        let soma =
          servicoTerceiro +
          materialConsumo +
          materialPermanente +
          viagemDiarias +
          outrosRecursos +
          recursoHumano;
        let valorTotal = helpers.formatarValor(soma);

        let valorNota = this.dados
          .filter((el) => el.prazo == index)
          .reduce((total, el) => total + el.valor, 0);
        let notas = helpers.formatarValor(valorNota);

        let lista = [];
        this.dados
          .filter((el) => el.prazo == index)
          .forEach((el) => {
            let aux = lista.find((el2) => el2.parcela == el.parcela);
            if (aux) {
              aux.valor += el.valor;
            } else {
              lista.push({
                parcela: el.parcela,
                valor: el.valor,
              });
            }
          });

        meses.push({
          value: index,
          text: `Mês ${index}`,
          valor: valorTotal,
          valorSoma: soma,
          rubricas: {
            servicoTerceiro: helpers.formatarValor(servicoTerceiro),
            recursoHumano: helpers.formatarValor(recursoHumano),
            materialConsumo: helpers.formatarValor(materialConsumo),
            materialPermanente: helpers.formatarValor(materialPermanente),
            viagemDiarias: helpers.formatarValor(viagemDiarias),
            outrosRecursos: helpers.formatarValor(outrosRecursos),
          },
          valorNota: valorNota,
          notas: notas,
          listaNotas: lista.map((el) => {
            return {
              tipo: "Parcela " + el.parcela,
              valor: helpers.formatarValor(el.valor),
              id: el.parcela,
            };
          }),
          total: helpers.formatarValor(soma + valorNota),
        });
      }
      return meses;
    },
  },
};
</script>
<style lang=""></style>
